export function possiblePrecision(num: number): string {
    if (num % 1 !== 0) {
        return num.toFixed(2);
    } else {
        return num.toFixed(0);
    }
}

export function priceInRupee(value: number): string {
    return possiblePrecision(value / 100);
}
